import { render, staticRenderFns } from "./HighlightsPlayIcon.vue?vue&type=template&id=0cf97cf8&scoped=true"
import script from "./HighlightsPlayIcon.vue?vue&type=script&lang=ts"
export * from "./HighlightsPlayIcon.vue?vue&type=script&lang=ts"
import style0 from "./HighlightsPlayIcon.vue?vue&type=style&index=0&id=0cf97cf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf97cf8",
  null
  
)

export default component.exports